module.exports = __webpack_public_path__ + "img/smooth-chill.b7d4c496.png";